import { ProductType } from 'graphql-query-contracts';
import { convertToUUID } from 'uuid-encoding';

type Filter = {
  id: string;
  value: string | string[];
};

const defaultProductTypes = [
  ProductType.ProductTypeServiceLabour,
  ProductType.ProductTypeServiceMaterials,
];

const defaultProduct = {
  types: defaultProductTypes,
  categoryId: '',
};

function getProductTypeFilter(filters: Filter[]) {
  const filter = filters.find(filter => filter.id === 'type');

  return filter;
}

function updateProductSettingsFilter(filter: Filter) {
  let productsSettings: { types: ProductType[]; categoryId: string } =
    defaultProduct;

  if (filter.value === ProductType.ProductTypeServiceLabour) {
    productsSettings = {
      ...defaultProduct,
      types: [ProductType.ProductTypeServiceLabour],
    };
  } else if (filter.value === ProductType.ProductTypeServiceMaterials) {
    productsSettings = {
      ...defaultProduct,
      types: [ProductType.ProductTypeServiceMaterials],
    };
  }

  return productsSettings;
}

export function setProductsSettings(filters: Filter[]) {
  const typeFilter = getProductTypeFilter(filters);

  if (typeFilter) {
    return updateProductSettingsFilter(typeFilter);
  }

  return defaultProduct;
}

export function setChargeCodes(filters: Filter[]) {
  const chargeCodes = filters.find(filter => filter.id === 'chargeCode');

  if (chargeCodes && Array.isArray(chargeCodes.value)) {
    return chargeCodes.value.map(id => convertToUUID(id));
  }

  return [];
}
